import { RouterModule, Routes } from "@angular/router";
import { ExternalLinkManagerComponent } from "./shared/components/external-link-manager/external-link-manager.component";
import { FullComponent } from "./shared/layouts/full/full.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { AclGuard } from "./core/acl/acl.guard";
import { UserRole } from "./core/models/user/user-role";
import { BlankComponent } from "./shared/layouts/blank/blank.component";
import { LoadingComponent } from "./modules/loading/pages/loading-page/loading.component";
import { NgModule } from "@angular/core";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./modules/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "/dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        canActivate: [AclGuard],
        data: { role: [UserRole.Net, UserRole.Plant], module: "dashboard" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: "anagrafica",
        canActivate: [AclGuard],
        data: { module: "user-details" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/user-details/user-details.module").then(
            (m) => m.UserDetailsModule,
          ),
      },
      // {
      //   path: "transactions",
      //   data: { role: [UserRole.Plant] },
      //   loadChildren: () =>
      //     import("./modules/transactions/transactions.module").then(
      //       (m) => m.TransactionsModule
      //     ),
      // },
      // {
      //   path: "closures",
      //   data: { role: [UserRole.Plant, UserRole.Net] },
      //   loadChildren: () =>
      //     import("./modules/closures/closures.module").then(
      //       (m) => m.ClosuresModule
      //     ),
      // },
      {
        path: "impianti",
        canActivate: [AclGuard],
        data: { role: [UserRole.Plant, UserRole.Net], module: "plants" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/plants/plants.module").then(
            (m) => m.PlantsModule,
          ),
      },
      {
        path: "clienti-pro",
        canActivate: [AclGuard],
        data: { role: [UserRole.Net], module: "bi" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/bi/bi.module").then(
            (m) => m.BI_ROUTES,
          ),
      },

      {
        path: "clienti",
        canActivate: [AclGuard],
        data: { role: [UserRole.Net], module: "clients" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/clients/clients.module").then(
            (m) => m.ClientsModule,
          ),
      },
      {
        path: "osservatorio-prezzi",
        canActivate: [AclGuard],
        data: { role: [UserRole.Plant, UserRole.Net], module: "ossPrezzi" },
        loadChildren: () =>
          import("@assoanalytics/app/modules/oss-prezzi/oss-prezzi.module").then(
            (m) => m.OssPrezziModule,
          ),
      },

      {
        path: "external-link",
        component: ExternalLinkManagerComponent,
      },
    ],
  },
  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "error",
        loadChildren: () =>
          import("@assoanalytics/app/modules/error/error.module").then(
            (m) => m.ErrorModule,
          ),
      },
    ],
  },
  {
    path: "goodbye",
    loadChildren: () =>
      import("@assoanalytics/app/modules/goodbye/goodbye.module").then(
        (m) => m.GoodbyeModule,
      ),
  },
  {
    path: "loading",
    component: LoadingComponent,
  },
  {
    path: "**",
    redirectTo: "error/page-not-found",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
